// MainFile.js (or WarehouseManagement.js)
import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { getSuppliers } from '../../../store/actions/dashboardAction';
import WarehouseCreateOrEditForm from './components/WarehouseCreateOrEditForm';

const WarehouseManagement = (props) => {
  let admin = localStorage.getItem("admin");
  if(!admin) {
    window.location.href = "/";
  }
  const { id } = useParams();
  const history = useHistory();
  
  useEffect(() => {
    props.getSuppliers({});
  }, []);

  return (
    <WarehouseCreateOrEditForm
      id={id}
      history={history}
      suppliers={props.suppliers}
    />
  );
};

const mapStateToProps = (state) => ({
  suppliers: state.dashboardReducer.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
  getSuppliers: (data) => getSuppliers(data, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseManagement);
